import { ReactNode } from "react";

export enum LinkPositions {
  START,
  END,
  NONE,
}

export interface NavigationLink {
  id: string;
  title: string;
  desktopPosition: LinkPositions;
  subMenu?: ReactNode;
  Component: ({
    children,
    className,
    onClick,
  }: {
    children: ReactNode;
    className?: string;
    onClick?: () => void;
  }) => JSX.Element;
  hide?: boolean;
}
